import { API } from "aws-amplify";
import axios from "axios";
import "containers/common/Detail.css";
import SLMEntityLinkList from "containers/slm/SLMEntityLinkList"; //new
import SLMOwnerLinkList from "containers/slm/SLMOwnerLinkList"; //new
import VolumeFoliosList from "containers/property/VolumeFoliosList";
import VolumeFoliosModal from "containers/property/VolumeFoliosModal";
import TitleDetailsList from "containers/property/TitleDetailsList";
import TitleDetailsModal from "containers/property/TitleDetailsModal";
import PropertyIntegrationsList from "containers/property/PropertyIntegrationsList";
import PropertyIntegrationsModal from "containers/property/PropertyIntegrationsModal";
import RefreshButton from "components/RefreshButton";

import React, { Component } from "react";
import { Button, Card, Col, Form, Row, Modal, Alert, Nav, Popover, OverlayTrigger } from "react-bootstrap";
import Select from "react-select";
import { PacmanLoader } from "react-spinners";
import "react-table/react-table.css";
import { LinkContainer } from "react-router-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CurrencyField from "components/CurrencyField";
import { ReactComponent as Info } from "../../images/Info.svg";

const CancelToken = axios.CancelToken;
const source = CancelToken.source();
const goLive = new Date("09 May 2023");

export default class SLMLeaseDetail extends Component {
  constructor(props) {
    super(props);

    this.updateTableState = this.updateTableState.bind(this);
    this.saveRecord = this.saveRecord.bind(this);
    this.deleteRecord = this.deleteRecord.bind(this);
    this.validateRelatedRecord = this.validateRelatedRecord.bind(this);
    this.getAgencies = this.getAgencies.bind(this);
    this.updateAgencyFields = this.updateAgencyFields.bind(this);
    this.updateVendorFields = this.updateVendorFields.bind(this);

    this.getTitleDetails = this.getTitleDetails.bind(this);
    this.getVolumeFolios = this.getVolumeFolios.bind(this);

    this.acceptIntegration = this.acceptIntegration.bind(this);
    this.rejectIntegration = this.rejectIntegration.bind(this);
    this.updateIntegrations = this.updateIntegrations.bind(this);
    this.getIntegrations = this.getIntegrations.bind(this);

    this.state = {
      titleDetailsSaved: false,
      volumeFoliosSaved: false,

      isLoading: null,
      isDeleting: null,
      lease: null,
      modified: false,
      showAlert: false,
      errorMessage: "",

      idList: [],
      previousId: null,
      nextId: null,
      currentIdIndex: null,

      addressFilter: { addressid: -1 },
      agencyFilter: { leaseid: parseInt(this.props.match.params.id), saleid: null, agentname: null },
      ownerFilter: { leaseid: parseInt(this.props.match.params.id), saleid: null, ownername: null },

      selectedSourceCategories1: null,
      selectedSourceCategories2: null,
      selectedSourceCategories3: null,
      selectedLeaseStatusCategories: null,
      selectedSpaceUseCategories: null,
      selectedBroadSpaceUseCategories: null,
      selectedQualityTypeCategories: null,
      selectedLeaseMethodCategories: null,
      selectedLevelCategories: null,
      selectedCarSpaceCategories: null,
      selectedOutgoingsCategories: null,
      selectedRentBasisCategories: null,
      selectedReviewBasisCategories: null,
      selectedRentPerAnnumBasisCategories: null,

      selectedSuburb: null,
      suburbOptions: [],
      entityLinks: [], //new
      ownerLinks: [], //new
      agencyOptions: [],
      agents: [], //new

      showAgencyDialog: false, //new
      saveForm: false, //new

      lease_id: null,

      hard_sequence: null,
      address_id: null,
      address_hard_sequence: null,
      building_name: null,
      floor_unit: null,
      street_no_low: null,
      street_no_high: null,
      street_name: null,
      extension: null,
      suburb: null,
      postcode: null,
      state_code: null,
      street_address_full: null,
      source_cat_id: null,
      source_cat: null,
      source_date: null,
      source_page: null,
      source_cat_1_id: null,
      source_cat_1: null,
      source_date_1: null,
      source_page_1: null,
      source_cat_2_id: null,
      source_cat_2: null,
      source_date_2: null,
      source_page_2: null,
      source_cat_3_id: null,
      source_cat_3: null,
      source_date_3: null,
      source_page_3: null,
      lease_commence_date: null,
      rent: null,
      rent_basis: null,
      asking_rent: null,
      space_use_id: null,
      space_use_code: null,
      space_use_name: null,
      broad_space_use_id: null,
      broad_space_use_code: null,
      quality_type_id: null,
      quality_type: null,
      term: null,
      options: null,
      outgoings: null,
      lease_basis: null,
      rent_basis_cat: null,
      tenant_area: null,
      lease_level: null,
      cars: null,
      car_rate: null,
      lease_type: null,
      lease_type_cat_id: null,
      lease_type_cat: null,
      level_description_cat_id: null,
      level_description_cat: null,
      rent_per_annum: null,
      rent_per_annum_basis_cat_id: null,
      rent_per_annum_basis_cat: null,
      outgoing_basis_cat_id: null,
      outgoing_basis_cat: null,
      lease_basis_cat_id: null,
      lease_basis_cat: null,
      lease_status_cat_id: null,
      lease_status_cat: null,
      car_space_descr_cat_id: null,
      car_space_descr_cat: null,
      lessee: null,
      owner: null,
      agent: null,
      agency: null,
      pending: null,
      estimated: null,
      review: null,
      print_month: null,
      prev_delivery: null,
      stat_date: null,
      editors_note: null,
      note_data: null,
      lease_notes: null,
      lease_notes_computed: null,
      created_date: null,
      created_by: null,
      last_edited_date: null,
      last_edited_by: null,
      archived_date: null,
      unit_number: null,

      titleDetails: [],
      showTitleDetailsDialog: false,

      volumeFolios: [],
      showVolumeFoliosDialog: false,

      integrations: [],

      title_details: null,
    };
  }

  async componentWillReceiveProps(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      // Clean component and reload?
      console.log("Resetting");
      window.location.reload();
    }
  }

  componentWillUnmount() {
    this.setState({ lease: [] });
    this.setState({ suburbOptions: [] });
    this.setState({ agentOptions: [] });
    this.setState({ sourcecategoryOptions: [] });
    this.setState({ leasestatuscategoryOptions: [] });
    this.setState({ spaceusecategoryOptions: [] });
    this.setState({ zoningcategoryOptions: [] });
    this.setState({ qualitytypecategoryOptions: [] });
    this.setState({ titlebasiscategoryOptions: [] });
    this.setState({ leasemethodcategoryOptions: [] });
    this.setState({ saledescribercategoryOptions: [] });
    this.setState({ incomebasiscategoryOptions: [] });
    this.setState({ areabasiscategoryOptions: [] });
    this.setState({ carspacecategoryOptions: [] });
  }

  async componentDidMount() {
    try {
      this.setState({ isLoading: true });

      if (this.props.match.params.id === "new") {
        const dt = new Date();
        const today = dt.getFullYear() + "-" + (dt.getMonth() + 1) + "-" + dt.getDate();

        this.setState((state) => ({
          created_date: new Date(),
          created_by: this.props.user,
          address_id: this.props.location.state.address_id ? this.props.location.state.address_id : null,
          building_name: this.props.location.state.building_name ? this.props.location.state.building_name : null,
          floor_unit: this.props.location.state.floor_unit ? this.props.location.state.floor_unit : null,
          street_no_low: this.props.location.state.street_no_low ? this.props.location.state.street_no_low : null,
          street_no_high: this.props.location.state.street_no_high ? this.props.location.state.street_no_high : null,
          street_name: this.props.location.state.street_name ? this.props.location.state.street_name : null,
          extension: this.props.location.state.extension ? this.props.location.state.extension : null,
          suburb: this.props.location.state.suburb ? this.props.location.state.suburb : null,
          state_code: this.props.location.state.state_code ? this.props.location.state.state_code : null,
          postcode: this.props.location.state.postcode ? this.props.location.state.postcode : null,
          stat_date: today,
          pending: false,
          lease_status_cat_id: 283,
          lease_status_cat: "Existing",
          estimated: false,
          quality_type_id: 2,
          quality_type: "Prime",
          space_use_id: 250,
          space_use_name: "SPACE TYPE UNKOWN",
          note_data: " ",
          print_month: today,
        }));

        if (this.props.location.state) {
          if (this.props.location.state.clone) {
            await this.cloneLease();
          } else {
            await this.syncroniseState();
          }
        }
        document.title = "New lease record";
      } else {
        await this.retrieveLease();
        await this.getVolumeFolios();
        await this.getTitleDetails();
        await this.getIntegrations();
        if (this.props.location.state) {
          if (this.props.location.state.hasOwnProperty("data")) {
            const idList = this.props.location.state.data;
            const currentIdIndex = idList.indexOf(parseInt(this.props.match.params.id, 10));

            let nextId = null;
            let previousId = null;

            if (currentIdIndex + 1 < idList.length) {
              nextId = idList[currentIdIndex + 1];
            }
            if (currentIdIndex > 0) {
              previousId = idList[currentIdIndex - 1];
            }
            this.setState({ idList: idList, nextId: nextId, previousId: previousId, currentIdIndex: currentIdIndex });
          }
        }

        //Get agency records NEW
        const entityLinks = await this.getEntityLinks(this.state.agencyFilter);
        this.setState({ entityLinks });

        const ownerLinks = await this.getOwnerLinks(this.state.ownerFilter);
        this.setState({ ownerLinks });

        document.title = "Lease: " + this.state.lease_id;
      }
      this.setState({
        addressFilter: { addressid: this.state.address_id },
        selectedSourceCategories1: { value: this.state.source_cat_1_id, label: this.state.source_cat_1 },
        selectedSourceCategories2: { value: this.state.source_cat_2_id, label: this.state.source_cat_2 },
        selectedSourceCategories3: { value: this.state.source_cat_3_id, label: this.state.source_cat_3 },
        selectedLeaseStatusCategories: { value: this.state.lease_status_cat_id, label: this.state.lease_status_cat },
        selectedSpaceUseCategories: { value: this.state.space_use_id, label: this.state.space_use_name },
        selectedBroadSpaceUseCategories: { value: this.state.broad_space_use_id, label: this.state.broad_space_use_code },
        selectedQualityTypeCategories: { value: this.state.quality_type_id, label: this.state.quality_type },
        selectedCarSpaceCategories: { value: this.state.car_space_descr_cat_id, label: this.state.car_space_descr_cat },
        selectedLeaseMethodCategories: { value: this.state.lease_type_cat_id, label: this.state.lease_type_cat },
        selectedLevelCategories: { value: this.state.level_description_cat_id, label: this.state.level_description_cat },
        selectedOutgoingsCategories: { value: this.state.outgoing_basis_cat_id, label: this.state.outgoing_basis_cat },
        selectedRentBasisCategories: { value: this.state.rent_basis, label: this.state.rent_basis_cat },
        selectedReviewBasisCategories: { value: this.state.lease_basis, label: this.state.lease_basis_cat },
        selectedRentPerAnnumBasisCategories: { value: this.state.rent_per_annum_basis_cat_id, label: this.state.rent_per_annum_basis_cat },
      });

      this.setState({ isLoading: false });
    } catch (e) {
      alert(e);
    }
  }

  async cloneLeaseParcels(clonedLeaseId, newLeaseId = null) {
    if (newLeaseId && this.state.titleDetails) {
      const parcels = this.state.titleDetails.map((p) => {
        return { ...p, lease_id: newLeaseId };
      });
      await API.post("colin", `/slmleases/${clonedLeaseId}/parcels_bulk/null`, { body: parcels, cancelToken: source.token });
      return;
    }

    const parcels = await API.get("colin", `/slmleases/${clonedLeaseId}/parcels`, { cancelToken: source.token });
    for (const parcel of parcels) {
      parcel.parcel_id = null;
      parcel.lease_id = null;
      parcel._cloned = true; // Signals to the back-end not to create integrations
    }
    this.setState({ titleDetails: parcels });
  }

  async cloneLeaseVolumeFolios(clonedLeaseId, newLeaseId = null) {
    if (newLeaseId && this.state.volumeFolios) {
      const volumeFolios = this.state.volumeFolios.map((vf) => {
        return { ...vf, lease_id: newLeaseId };
      });
      await API.post("colin", `/slmleases/${newLeaseId}/volume_folios_bulk/null`, { body: volumeFolios, cancelToken: source.token });
      return;
    }

    const volumeFolios = await API.get("colin", `/slmleases/${clonedLeaseId}/volume_folios`, { cancelToken: source.token });
    for (const volumeFolio of volumeFolios) {
      volumeFolio.volume_folio_id = null;
      volumeFolio.lease_id = null;
    }
    this.setState({ volumeFolios: volumeFolios });
  }

  async cloneLeaseIntegrations(clonedLeaseId, newLeaseId = null) {
    if (newLeaseId && this.state.integrations) {
      const integrations = this.state.integrations.map((i) => {
        return { ...i, lease_id: newLeaseId };
      });
      await API.post("colin", `/slmleases/${newLeaseId}/integrations_bulk/null`, { body: integrations, cancelToken: source.token });
      return;
    }

    const integrations = await API.get("colin", `/slmleases/${clonedLeaseId}/integrations`, { cancelToken: source.token });
    for (const integration of integrations) {
      integration.integration_id = null;
      integration.lease_id = null;
    }
    this.setState({ integrations: integrations });
  }

  async cloneLease() {
    console.log("Clone lease");
    const lease = this.props.location.state.clone;
    const {
      address_id,
      address_hard_sequence,
      street_address_full,
      building_name,
      street_no_low,
      street_no_high,
      street_name,
      extension,
      suburb,
      postcode,
      state_code,
      tenant_area,

      rent,
      rent_basis,
      rent_basis_cat,
      asking_rent,
      space_use_id,
      space_use_code,
      space_use_name,
      broad_space_use_id,
      broad_space_use_code,
      quality_type_id,
      quality_type,
      outgoings,
      lease_basis,
      cars,
      car_rate,
      lease_type,
      lease_type_cat_id,
      lease_type_cat,
      lease_level,
      level_description_cat_id,
      level_description_cat,
      rent_per_annum,
      rent_per_annum_basis_cat_id,
      rent_per_annum_basis_cat,
      outgoing_basis_cat_id,
      outgoing_basis_cat,
      lease_basis_cat_id,
      lease_basis_cat,
      lease_status_cat_id,
      lease_status_cat,
      car_space_descr_cat_id,
      car_space_descr_cat,
      pending,
      estimated,
      review,
      unit_number,
      lease_notes,
    } = lease;

    this.setState({
      lease,
      address_id,
      address_hard_sequence,
      street_address_full,
      building_name,
      street_no_low,
      street_no_high,
      street_name,
      extension,
      suburb,
      postcode,
      state_code,
      tenant_area,

      rent,
      rent_basis,
      rent_basis_cat,
      asking_rent,
      space_use_id,
      space_use_code,
      space_use_name,
      broad_space_use_id,
      broad_space_use_code,
      quality_type_id,
      quality_type,
      outgoings,
      lease_basis,
      cars,
      car_rate,
      lease_type,
      lease_type_cat_id,
      lease_type_cat,
      lease_level,
      level_description_cat_id,
      level_description_cat,
      rent_per_annum,
      rent_per_annum_basis_cat_id,
      rent_per_annum_basis_cat,
      outgoing_basis_cat_id,
      outgoing_basis_cat,
      lease_basis_cat_id,
      lease_basis_cat,
      lease_status_cat_id,
      lease_status_cat,
      car_space_descr_cat_id,
      car_space_descr_cat,
      pending,
      estimated,
      review,
      unit_number,
      lease_notes,
    });

    this.cloneLeaseParcels(lease.lease_id, null);
    this.cloneLeaseVolumeFolios(lease.lease_id, null);
    this.cloneLeaseIntegrations(lease.lease_id, null);

    const clonedLease = await API.get("colin", `/slmleases/${lease.lease_id}`);
    this.setState({ title_details: clonedLease.title_details });
    this.setState({ lease_notes_computed: clonedLease.lease_notes_computed });
  }

  async retrieveLease() {
    const lease = await this.getLease();
    const {
      lease_id,
      origin_db,
      hard_sequence,
      address_id,
      address_hard_sequence,
      building_name,
      floor_unit,
      street_no_low,
      street_no_high,
      street_name,
      extension,
      suburb,
      postcode,
      state_code,
      street_address_full,
      source_cat_id,
      source_cat,
      source_date,
      source_page,
      source_cat_1_id,
      source_cat_1,
      source_date_1,
      source_page_1,
      source_cat_2_id,
      source_cat_2,
      source_date_2,
      source_page_2,
      source_cat_3_id,
      source_cat_3,
      source_date_3,
      source_page_3,
      lease_commence_date,
      rent,
      rent_basis,
      rent_basis_cat,
      space_use_id,
      space_use_code,
      space_use_name,
      broad_space_use_id,
      broad_space_use_code,
      quality_type_id,
      quality_type,
      term,
      options,
      outgoings,
      lease_basis,
      tenant_area,
      lease_level,
      cars,
      car_rate,
      lease_type,
      lease_type_cat_id,
      lease_type_cat,
      level_description_cat_id,
      level_description_cat,
      rent_per_annum,
      rent_per_annum_basis_cat_id,
      rent_per_annum_basis_cat,
      outgoing_basis_cat_id,
      outgoing_basis_cat,
      lease_basis_cat_id,
      lease_basis_cat,
      lease_status_cat_id,
      lease_status_cat,
      car_space_descr_cat_id,
      car_space_descr_cat,
      lessee,
      owner,
      agent,
      agency,
      pending,
      estimated,
      review,
      print_month,
      prev_delivery,
      stat_date,
      editors_note,
      note_data,
      lease_notes,
      lease_notes_computed,
      created_date,
      created_by,
      last_edited_date,
      last_edited_by,
      unit_number,
      title_details,
    } = lease;

    this.setState({
      lease,
      lease_id,
      origin_db,
      hard_sequence,
      address_id,
      address_hard_sequence,
      building_name,
      floor_unit,
      street_no_low,
      street_no_high,
      street_name,
      extension,
      suburb,
      postcode,
      state_code,
      street_address_full,
      source_cat_id,
      source_cat,
      source_date,
      source_page,
      source_cat_1_id,
      source_cat_1,
      source_date_1,
      source_page_1,
      source_cat_2_id,
      source_cat_2,
      source_date_2,
      source_page_2,
      source_cat_3_id,
      source_cat_3,
      source_date_3,
      source_page_3,
      lease_commence_date,
      rent,
      rent_basis,
      rent_basis_cat,
      space_use_id,
      space_use_code,
      space_use_name,
      broad_space_use_id,
      broad_space_use_code,
      quality_type_id,
      quality_type,
      term,
      options,
      outgoings,
      lease_basis,
      tenant_area,
      lease_level,
      cars,
      car_rate,
      lease_type,
      lease_type_cat_id,
      lease_type_cat,
      level_description_cat_id,
      level_description_cat,
      rent_per_annum,
      rent_per_annum_basis_cat_id,
      rent_per_annum_basis_cat,
      outgoing_basis_cat_id,
      outgoing_basis_cat,
      lease_basis_cat_id,
      lease_basis_cat,
      lease_status_cat_id,
      lease_status_cat,
      car_space_descr_cat_id,
      car_space_descr_cat,
      lessee,
      owner,
      agent,
      agency,
      pending,
      estimated,
      review,
      print_month,
      prev_delivery,
      stat_date,
      editors_note,
      note_data,
      lease_notes,
      lease_notes_computed,
      created_date,
      created_by,
      last_edited_date,
      last_edited_by,
      unit_number,
      title_details,
    });
  }

  async syncroniseState() {
    console.log("syncroniseState");
    const lease = {
      lease_id: this.state.lease_id,
      origin_db: this.state.origin_db,
      hard_sequence: this.state.hard_sequence,
      address_id: this.state.address_id,
      address_hard_sequence: this.state.address_hard_sequence,
      building_name: this.state.building_name,
      floor_unit: this.state.floor_unit,
      street_no_low: this.state.street_no_low,
      street_no_high: this.state.street_no_high,
      street_name: this.state.street_name,
      extension: this.state.extension,
      suburb: this.state.suburb,
      postcode: this.state.postcode,
      state_code: this.state.state_code,
      street_address_full: this.state.street_address_full,
      source_cat_id: this.state.source_cat_id,
      source_cat: this.state.source_cat,
      source_date: this.state.source_date,
      source_page: this.state.source_page,
      source_cat_1_id: this.state.source_cat_1_id,
      source_cat_1: this.state.source_cat_1,
      source_date_1: this.state.source_date_1,
      source_page_1: this.state.source_page_1,
      source_cat_2_id: this.state.source_cat_2_id,
      source_cat_2: this.state.source_cat_2,
      source_date_2: this.state.source_date_2,
      source_page_2: this.state.source_page_2,
      source_cat_3_id: this.state.source_cat_3_id,
      source_cat_3: this.state.source_cat_3,
      source_date_3: this.state.source_date_3,
      source_page_3: this.state.source_page_3,
      lease_commence_date: this.state.lease_commence_date,
      rent: this.state.rent,
      rent_basis: this.state.rent_basis,
      rent_basis_cat: this.state.rent_basis_cat,
      asking_rent: this.state.asking_rent,
      space_use_id: this.state.space_use_id,
      space_use_code: this.state.space_use_code,
      space_use_name: this.state.space_use_name,
      broad_space_use_id: this.state.broad_space_use_id,
      broad_space_use_code: this.state.broad_space_use_code,
      quality_type_id: this.state.quality_type_id,
      quality_type: this.state.quality_type,
      term: this.state.term,
      options: this.state.options,
      outgoings: this.state.outgoings,
      lease_basis: this.state.lease_basis,
      tenant_area: this.state.tenant_area,
      lease_level: this.state.lease_level,
      cars: this.state.cars,
      car_rate: this.state.car_rate,
      lease_type: this.state.lease_type,
      lease_type_cat_id: this.state.lease_type_cat_id,
      lease_type_cat: this.state.lease_type_cat,
      level_description_cat_id: this.state.level_description_cat_id,
      level_description_cat: this.state.level_description_cat,
      rent_per_annum: this.state.rent_per_annum,
      rent_per_annum_basis_cat_id: this.state.rent_per_annum_basis_cat_id,
      rent_per_annum_basis_cat: this.state.rent_per_annum_basis_cat,
      outgoing_basis_cat_id: this.state.outgoing_basis_cat_id,
      outgoing_basis_cat: this.state.outgoing_basis_cat,
      lease_basis_cat_id: this.state.lease_basis_cat_id,
      lease_basis_cat: this.state.lease_basis_cat,
      lease_status_cat_id: this.state.lease_status_cat_id,
      lease_status_cat: this.state.lease_status_cat,
      car_space_descr_cat_id: this.state.car_space_descr_cat_id,
      car_space_descr_cat: this.state.car_space_descr_cat,
      lessee: this.state.lessee,
      owner: this.state.owner,
      agent: this.state.agent,
      agency: this.state.agency,
      pending: this.state.pending,
      estimated: this.state.estimated,
      review: this.state.review,
      print_month: this.state.print_month,
      prev_delivery: this.state.prev_delivery,
      stat_date: this.state.stat_date,
      editors_note: this.state.editors_note,
      note_data: this.state.note_data,
      lease_notes: this.state.lease_notes,
      lease_notes_computed: this.state.lease_notes_computed,
      created_date: this.state.created_date,
      created_by: this.state.created_by,
      last_edited_date: this.state.last_edited_date,
      last_edited_by: this.state.last_edited_by,
      archived_date: this.state.archived_date,
      unit_number: this.state.unit_number,
      title_details: this.state.title_details,
    };
    this.setState({ lease });
  }

  async getLease() {
    return API.get("colin", `/slmleases/${this.props.match.params.id}`);
  }

  async saveLease(lease) {
    this.setState({ last_edited_by: this.props.user });
    if (this.props.match.params.id === "new" && this.state.lease_id === null) {
      this.setState({ created_by: this.props.user });
      const response = await API.post("colin", `/slmleases/new`, { body: lease });
      try {
        return await response;
      } catch (error) {
        alert(error + ". Please refresh the page (F5) to try again.");
      }
    }
    const response = API.put("colin", `/slmleases/${this.state.lease_id}`, { body: lease });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  //new

  async getEntityLinks(filter) {
    const response = API.get("colin", `/slmentitylinks`, { queryStringParameters: filter });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async getOwnerLinks(filter) {
    const response = API.get("colin", `/slmownerlinks`, { queryStringParameters: filter });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async getAgencies(filter) {
    const response = API.get("colin", `/slmentities`, { queryStringParameters: filter });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async getAgents(filter) {
    const response = API.get("colin", `/slmagents`, { queryStringParameters: filter });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async getOwners(filter) {
    const response = API.get("colin", `/slmowners`, { queryStringParameters: filter });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async getContacts(filter) {
    const response = API.get("colin", `/slmowners/${filter.orgid}/slmcontacts`, { queryStringParameters: filter });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  //new
  async updateTableState(data, set) {
    this.setState({
      [set]: data,
    });
    return true;
  }
  //new
  saveRecord(record, endpoint, id) {
    console.log(record);
    console.log("endpoint:", endpoint, "id:", id);
    record.last_edited_by = this.props.user;
    //If the record is a new record perform a post
    if (record.hasOwnProperty("new_record")) {
      if (record.new_record === true) {
        if (endpoint === "slmTitleDetails") {
          this.setState({ titleDetailsSaved: true });
          const response = API.post("colin", `/slmleases/${record["lease_id"]}/parcels/${record[id]}`, { body: record });
          return response;
        }

        if (endpoint === "slmVolumeFolios") {
          this.setState({ volumeFoliosSaved: true });
          return API.post("colin", `/slmleases/${record["lease_id"]}/volume_folios/${record[id]}`, { body: record });
        }

        if (endpoint === "slmPropertyIntegrations") {
          const response = API.POST("colin", `/slmleases/${record["lease_id"]}/integrations/${record[id]}`, { body: record });
          response.then((response) => {
            if (response.result === true) {
              this.getTitleDetails();
            }
          });
          return response;
        }

        record.last_edited_by = this.props.user;
        return API.post("colin", `/slm${endpoint.toLowerCase()}/new`, {
          body: record,
        });
      }
    }

    if (endpoint === "slmTitleDetails") {
      this.setState({ titleDetailsSaved: true });
      const response = API.put("colin", `/slmleases/${record["lease_id"]}/parcels/${record[id]}`, { body: record });
      return response;
    }

    if (endpoint === "slmVolumeFolios") {
      this.setState({ volumeFoliosSaved: true });
      return API.put("colin", `/slmleases/${record["lease_id"]}/volume_folios/${record[id]}`, { body: record });
    }

    if (endpoint === "slmPropertyIntegrations") {
      const response = API.put("colin", `/slmleases/${record["lease_id"]}/integrations/${record[id]}`, { body: record });
      response.then((response) => {
        if (response.result === true) {
          this.getTitleDetails();
        }
      });
      return response;
    }

    return API.put("colin", `/slm${endpoint.toLowerCase()}/${record[id]}`, {
      body: record,
    });
  }

  deleteRecord(endpoint, params) {
    return API.del("colin", `/${endpoint}`, { queryStringParameters: params });
  }

  validateRelatedRecord(record, set) {
    //address
    if (set === "lease") {
      if (this.state.stat_date === null) {
        return [false, "You must enter a stat date"];
      }

      if (this.state.space_use_id === null) {
        return [false, "You must select a space use."];
      }

      if (this.state.quality_type_id === null) {
        return [false, "You must select a quality type."];
      }

      if (this.state.lease_level) {
        if (this.state.lease_level.length > 14) {
          return [false, "Suite/level cannot be longer than 14 characters."];
        }
      }
    }

    return [true, ""];
  }

  handleEnterCurrentIdIndex = (event) => {
    if (event.keyCode === 13 || event.keyCode === 9) {
      this.handleGoToRecord();
    }
  };

  handleGoToRecord = (event) => {
    console.log(this.state.idList.length);
    if (this.state.currentIdIndex >= 0 && this.state.currentIdIndex < this.state.idList.length) {
      this.props.history.push({ pathname: `/slmleases/${this.state.idList[this.state.currentIdIndex]}`, state: { data: this.state.idList } });
    } else {
      alert("Page no not in range.");
    }
  };

  handleCurrentIdIndexChange = (event) => {
    const val = event.target.value.replace(/[^0-9.]/g, "");
    this.setState({ [event.target.id]: val - 1 });
  };

  handleSource1Change = (selectedSourceCategories1) => {
    if (selectedSourceCategories1) {
      this.setState({ selectedSourceCategories1, source_cat_1_id: selectedSourceCategories1.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedSourceCategories1: { value: null, label: null }, source_cat_1_id: null, modified: true }, this.handleBlur);
    }
  };
  handleSource2Change = (selectedSourceCategories2) => {
    if (selectedSourceCategories2) {
      this.setState({ selectedSourceCategories2, source_cat_2_id: selectedSourceCategories2.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedSourceCategories2: { value: null, label: null }, source_cat_2_id: null, modified: true }, this.handleBlur);
    }
  };

  handleSource3Change = (selectedSourceCategories3) => {
    if (selectedSourceCategories3) {
      this.setState({ selectedSourceCategories3, source_cat_3_id: selectedSourceCategories3.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedSourceCategories3: { value: null, label: null }, source_cat_3_id: null, modified: true }, this.handleBlur);
    }
  };

  handleStatusChange = (selectedLeaseStatusCategories) => {
    if (selectedLeaseStatusCategories) {
      this.setState({ selectedLeaseStatusCategories, lease_status_cat_id: selectedLeaseStatusCategories.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedLeaseStatusCategories: { value: null, label: null }, lease_status_cat_id: null, modified: true }, this.handleBlur);
    }
  };

  handleRentBasisCategoryChange = (selectedRentBasisCategories) => {
    if (selectedRentBasisCategories) {
      this.setState({ selectedRentBasisCategories, rent_per_annum_basis_cat_id: selectedRentBasisCategories.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedRentBasisCategories: { value: null, label: null }, rent_per_annum_basis_cat_id: null, modified: true }, this.handleBlur);
    }
  };

  handleReviewBasisCategoryChange = (selectedReviewBasisCategories) => {
    if (selectedReviewBasisCategories) {
      this.setState({ selectedReviewBasisCategories, lease_basis_cat_id: selectedReviewBasisCategories.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedReviewBasisCategories: { value: null, label: null }, lease_basis_cat_id: null, modified: true }, this.handleBlur);
    }
  };

  handleLevelCategoryChange = (selectedLevelCategories) => {
    if (selectedLevelCategories) {
      this.setState({ selectedLevelCategories, level_description_cat_id: selectedLevelCategories.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedLevelCategories: { value: null, label: null }, level_description_cat_id: null, modified: true }, this.handleBlur);
    }
  };

  handleOutgoingsCategoryChange = (selectedOutgoingsCategories) => {
    if (selectedOutgoingsCategories) {
      this.setState({ selectedOutgoingsCategories, outgoing_basis_cat_id: selectedOutgoingsCategories.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedOutgoingsCategories: { value: null, label: null }, outgoing_basis_cat_id: null, modified: true }, this.handleBlur);
    }
  };

  handleRentBasisCategoryChange = (selectedRentBasisCategories) => {
    if (selectedRentBasisCategories) {
      this.setState({ selectedRentBasisCategories, rent_basis: selectedRentBasisCategories.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedRentBasisCategories: { value: null, label: null }, rent_basis: null, modified: true }, this.handleBlur);
    }
  };

  handleRentPerAnnumBasisCategoryChange = (selectedRentPerAnnumBasisCategories) => {
    if (selectedRentPerAnnumBasisCategories) {
      this.setState({ selectedRentPerAnnumBasisCategories, rent_per_annum_basis_cat_id: selectedRentPerAnnumBasisCategories.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedRentPerAnnumBasisCategories: { value: null, label: null }, rent_per_annum_basis_cat_id: null, modified: true }, this.handleBlur);
    }
  };

  handleBroadSpaceUseChange = async (selectedBroadSpaceUseCategories) => {
    if (selectedBroadSpaceUseCategories) {
      this.setState({ selectedBroadSpaceUseCategories, broad_space_use_id: selectedBroadSpaceUseCategories.value, modified: true, selectedSpaceUseCategories: { value: null, label: null }, space_use_id: null }, this.handleBlur);
    } else {
      this.setState({ selectedBroadSpaceUseCategories: { value: null, label: null }, broad_space_use_id: null, modified: true, selectedSpaceUseCategories: { value: null, label: null }, space_use_id: null }, this.handleBlur);
    }
  };

  handleSpaceUseChange = (selectedSpaceUseCategories) => {
    if (selectedSpaceUseCategories) {
      this.setState(
        {
          selectedSpaceUseCategories,
          space_use_id: selectedSpaceUseCategories.value,
          broad_space_use_id: selectedSpaceUseCategories.supplementary_details.broad_space_use_id,
          modified: true,
          selectedBroadSpaceUseCategories: { value: selectedSpaceUseCategories.supplementary_details.broad_space_use_id, label: selectedSpaceUseCategories.supplementary_details.broad_space_use_code },
        },
        this.handleBlur
      );
    } else {
      this.setState({ selectedSpaceUseCategories: { value: null, label: null }, space_use_id: null, modified: true }, this.handleBlur);
    }
  };

  handleQualityTypeChange = (selectedQualityTypeCategories) => {
    if (selectedQualityTypeCategories) {
      this.setState({ selectedQualityTypeCategories, quality_type_id: selectedQualityTypeCategories.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedQualityTypeCategories: { value: null, label: null }, quality_type_id: null, modified: true }, this.handleBlur);
    }
  };

  handleLeaseMethodChange = (selectedLeaseMethodCategories) => {
    if (selectedLeaseMethodCategories) {
      const lease_type = this.props.leaseTypes.filter((a) => {
        if (a.value === selectedLeaseMethodCategories.value) {
          return true;
        } else {
          return false;
        }
      });

      this.setState({ selectedLeaseMethodCategories, lease_type: lease_type[0].label, lease_type_cat_id: selectedLeaseMethodCategories.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedLeaseMethodCategories: { value: null, label: null }, lease_type_cat_id: null, sale_type: null, modified: true }, this.handleBlur);
    }
  };

  handleCarSpaceChange = (selectedCarSpaceCategories) => {
    if (selectedCarSpaceCategories) {
      this.setState({ selectedCarSpaceCategories, car_space_descr_cat_id: selectedCarSpaceCategories.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedCarSpaceCategories: { value: null, label: null }, car_space_descr_cat_id: null, modified: true }, this.handleBlur);
    }
  };

  handleChange = (event) => {
    this.setState({ [event.target.id]: event.target.value.trimStart() });
    this.setState({ modified: true });
  };

  handlePercentChange = (event) => {
    let val = event.target.value.replace(/[^0-9.%]/g, "");
    this.setState({
      [event.target.id]: val,
    });
    this.setState({ modified: true });
  };

  handleNumberChange = (event) => {
    let val = event.target.value.replace(/[^0-9.]/g, "");
    this.setState({
      [event.target.id]: val,
    });
    this.setState({ modified: true });
  };

  handleMoneyChange = (event) => {
    if (event.target.value !== "") {
      let val = event.target.value.replace(/[^0-9.]/g, "").replace(/(?<=[.][0-9]{2})[0-9]*/g, "");
      this.setState({ [event.target.id]: val, modified: true });
    } else {
      this.setState({ [event.target.id]: null, modified: true });
    }
  };

  handleDateChange(date, name) {
    var options = { year: "numeric", month: "long", day: "numeric" };

    var dt = new Date(date);
    const today = new Date();

    if (name === "print_month") {
      if (dt.getTime() < today.getTime()) {
        alert("Delivery date cannot be earlier than today");
        return;
      }
    }
    if (date) {
      if (name === "lease_commence_date") {
        this.setState({
          stat_date: dt.toLocaleDateString("en-AU", options),
          modified: true,
        });
      }
      this.setState({
        [name]: dt.toLocaleDateString("en-AU", options),
        modified: true,
      });
    } else {
      this.setState({
        [name]: null,
        modified: true,
      });
    }
    this.setState({ modified: true });
  }

  handleCheckBoxChange = (event) => {
    let name = event.target.name;
    this.setState(
      {
        [name]: event.target.checked,
      },
      this.handleBlur
    );
    this.setState({ modified: true });
  };

  handleRedeliver = async (event) => {
    var options = { year: "numeric", month: "long", day: "numeric" };
    const today = new Date();

    const delivery_date = new Date(this.state.print_month);
    console.log(delivery_date);
    //If the delivery date is today do nothing
    if (!this.state.print_month) {
      alert("Delivery date cannot be empty");
      return;
    } else {
      if (today.getDate() === delivery_date.getDate() && today.getMonth() === delivery_date.getMonth() && today.getFullYear() === delivery_date.getFullYear()) {
        alert("Delivery date cannot be today");
        return;
      } else if ((today.getDate() < delivery_date.getDate() && today.getMonth() === delivery_date.getMonth() && today.getFullYear() === delivery_date.getFullYear()) || (today.getMonth() < delivery_date.getMonth() && today.getFullYear() === delivery_date.getFullYear()) || today.getFullYear() < delivery_date.getFullYear()) {
        alert("Delivery date cannot be in the past");
        return;
      } else {
        this.setState({ prev_delivery: this.state.print_month, print_month: today.toLocaleDateString("en-AU", options), modified: true }, this.handleBlur);
      }
    }
  };

  async handleRentChange(event) {
    if (!event) {
      return;
    }
    const col = event.target.id;
    const currencyFormatter = new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    if (col === "tenant_area") {
      if (this.state.tenant_area > 0) {
        if (this.state.rent > 0) {
          const rent_per_annum = Math.round(this.state.rent * this.state.tenant_area);

          const confirmed = this.state.rent_per_annum ? window.confirm(`Is it OK to overwrite the current value of Rent Per Annum with ${currencyFormatter.format(rent_per_annum)}?`) : true;

          if (!confirmed) {
            return;
          } else {
            this.setState({ rent_per_annum });
            return true;
          }
        } else if (this.state.rent_per_annum > 0) {
          const rent = Math.round(this.state.rent_per_annum / this.state.tenant_area);
          const confirmed = this.state.rent ? window.confirm(`Is it OK to overwrite the current value of Rent Per SQM with ${currencyFormatter.format(rent)}?`) : true;

          if (!confirmed) {
            return;
          } else {
            this.setState({ rent });
            return true;
          }
        }
      } else {
        const rent = "";
        const confirmed = this.state.rent ? window.confirm(`Is it OK to overwrite the current value of Rent Per SQM with ${currencyFormatter.format(rent)}?`) : false;

        if (!confirmed) {
          return;
        } else {
          this.setState({ rent });
          return true;
        }
      }
    }

    if (col === "rent") {
      if (this.state.rent > 0) {
        if (this.state.tenant_area > 0) {
          const rent_per_annum = Math.round(this.state.rent * this.state.tenant_area);
          const confirmed = this.state.rent_per_annum ? window.confirm(`Is it OK to overwrite the current value of Rent Per Annum with ${currencyFormatter.format(rent_per_annum)}?`) : true;

          if (!confirmed) {
            return;
          } else {
            this.setState({ rent_per_annum });
            return true;
          }
        } else if (this.state.rent_per_annum > 0) {
          const tenant_area = Math.round(this.state.rent_per_annum / this.state.rent);
          const confirmed = this.state.tenant_area ? window.confirm(`Is it OK to overwrite the current value of Area with ${tenant_area}?`) : true;

          if (!confirmed) {
            return;
          } else {
            this.setState({ tenant_area });
            return true;
          }
        }
      }
    }

    if (col === "rent_per_annum") {
      if (this.state.rent_per_annum > 0) {
        if (this.state.tenant_area > 0) {
          const rent = Math.round(this.state.rent_per_annum / this.state.tenant_area);
          const confirmed = this.state.rent ? window.confirm(`Is it OK to overwrite the current value of Rent Per SQM with ${currencyFormatter.format(rent)}?`) : true;

          if (!confirmed) {
            return;
          } else {
            this.setState({ rent });
            return true;
          }
        } else if (this.state.rent > 0) {
          const tenant_area = Math.round(this.state.rent_per_annum / this.state.rent);
          const confirmed = this.state.tenant_area ? window.confirm(`Is it OK to overwrite the current value of Area with ${tenant_area}?`) : true;

          if (!confirmed) {
            return;
          } else {
            this.setState({ tenant_area });
            return true;
          }
        }
      }
    }
  }
  //rent_per_annum
  //rent

  handleBlur = async (event) => {
    if (event) {
      event.persist();
    }
    if (event && event.target.id === "unit_number" && this.state.unit_number) {
      alert("Please note: this is to be used only where the record relates to a strata unit. Suite or Level information should not be entered in Unit Number.");
    }
    if (this.state.modified === true) {
      await this.handleRentChange(event);
      this.setState({ showAlert: false, last_edited_by: this.props.user });
      await this.syncroniseState();
      const validation = this.validateRelatedRecord(this.state.lease, "lease");
      if (validation[0] === true) {
        if (validation[1] !== "") {
          this.setState({ errorMessage: validation[1] });
          this.setState({ showAlert: true });
        }
        try {
          this.setState((state) => ({ modified: false }));
          if (this.props.match.params.id === "new") {
            this.setState({ isLoading: true });
            await this.setState({ lease: { ...this.state.lease, _cloned: false } });
          }
          console.log("Saving lease");
          const result = await this.saveLease(this.state.lease);
          this.setState({ isLoading: false });
          console.log(result);
          if (result.result === false) {
            alert(result.error_message);
          } else {
            if (this.props.match.params.id === "new") {
              this.setState((state) => ({ lease_id: result.id }));

              if (this.props.location.state.clone) {
                await this.cloneLeaseParcels(null, result.id);
                await this.cloneLeaseVolumeFolios(null, result.id);
                await this.cloneLeaseIntegrations(null, result.id);
              }

              this.props.history.push("/slmleases/" + result.id);
            } else {
              if (event && event.target.id === "unit_number") {
                // Address matching
                this.getIntegrations();
                this.getTitleDetails();
                // this.togglePropertyIntegrationsModal();
              }

              if (event && event.target.id === "lease_notes") {
                this.updateTitleDetailsString();
              }
            }
          }
        } catch (e) {
          alert(e);
        }
      } else {
        this.setState({ errorMessage: validation[1] });
        this.setState({ showAlert: true });
      }
    }
  };

  updateVendorFields() {
    if (this.state.ownerLinks.filter((e) => e.type === "Lessor" && e.name !== "" && e.name !== null).length > 0) {
      let vendors = this.state.ownerLinks.filter((e) => e.type === "Lessor" && e.name !== "" && e.name !== null).map((e) => (e.name || "").trimEnd());

      //dedupe vendors
      const vendorsSet = new Set(vendors);
      vendors = [...vendorsSet];
      const vendorsString = vendors.join("; ");
      console.log(vendorsString);

      this.setState({ owner: vendorsString, modified: true }, this.handleBlur);
    } else {
      if (this.state.owner) {
        const confirmed = window.confirm("Do you want to clear the Lessor form field?");

        if (confirmed && this.state.owner) {
          this.setState({ owner: "", modified: true }, this.handleBlur);
        }
      }
    }

    if (this.state.ownerLinks.filter((e) => e.type === "Lessee" && e.name !== "" && e.name !== null).length > 0) {
      let buyers = this.state.ownerLinks.filter((e) => e.type === "Lessee" && e.name !== "" && e.name !== null).map((e) => (e.name || "").trimEnd());

      //dedupe vendors
      const buyersSet = new Set(buyers);
      buyers = [...buyersSet];
      const buyersString = buyers.join("; ");
      console.log(buyersString);

      this.setState({ lessee: buyersString, modified: true }, this.handleBlur);
    } else {
      if (this.state.lessee) {
        const confirmed = window.confirm("Do you want to clear the Lessee form field?");

        if (confirmed && this.state.lessee) {
          this.setState({ lessee: "", modified: true }, this.handleBlur);
        }
      }
    }
  }

  updateAgencyFields() {
    if (this.state.entityLinks.length > 0) {
      let agencies = this.state.entityLinks.filter((f) => f.name !== "" && f.name !== null).map((e) => (e.name || "").trimEnd());

      //dedupe agencies
      const agenciesSet = new Set(agencies);
      agencies = [...agenciesSet];
      const agenciesString = agencies.sort().slice(0, 2).join("; ");
      console.log(agenciesString);

      let agentString = "";
      if (agencies.length === 1) {
        let agents = this.state.entityLinks
          .filter((f) => f.agent_name !== "" && f.agent_name !== null)
          .map((e) => e.agent_name)
          .sort();
        //dedupe agencies
        const agentsSet = new Set(agents);
        agents = [...agentsSet];
        agentString = agents.join("; ");
      } else {
        for (let x = 0; x < 2; x++) {
          let agents = this.state.entityLinks
            .filter((e) => (e.name || "").trimEnd() === agencies[x] && e.agent_name !== "")
            .map((e) => e.agent_name)
            .sort();
          console.log(agents);
          if (agents.length > 0) {
            if (agents[0] !== null && agents[0] !== " ") {
              agentString = (agentString + " " + agencies[x]).trim();
              //dedupe agencies
              const agentsSet = new Set(agents);
              agents = [...agentsSet];

              agentString = agentString + ": " + agents.slice(0, 2).join("; ") + ".";
            }
          }
        }
      }
      this.setState({ agency: agenciesString, agent: agentString, modified: true }, this.handleBlur);
    } else {
      this.setState({ agency: "", agent: "", modified: true }, this.handleBlur);
    }
  }

  toggleSLMAgencyModal = async () => {
    await this.setState((state) => ({
      showAgencyDialog: !this.state.showAgencyDialog,
    }));
    //Get agency records
    if (this.state.showAgencyDialog === false) {
      console.log("Inside about to get agencies");
      const agencies = await this.getAgencies(this.state.agencyFilter);
      this.setState({ agencies });
    }
  };

  deleteLease() {
    return API.del("colin", `/slmlease/${this.props.match.params.id}`);
  }

  handleDelete = async (event) => {
    event.preventDefault();

    const confirmed = window.confirm("Are you sure you want to delete this lease?");

    if (!confirmed) {
      return;
    } else {
      this.setState({ archived_date: new Date() }, () =>
        this.syncroniseState().then(async () => {
          const result = await this.saveLease(this.state.lease);
          if (result.result === false) {
            alert(result.error_message);
          } else {
            this.props.history.push("/slmaddresses/" + this.state.address_id);
          }
        })
      );
    }
  };

  handleSuburbChange = (selectedSuburb) => {
    this.setState({ selectedSuburb });
  };

  getTitleDetails() {
    try {
      API.get("colin", `/slmleases/${this.state.lease_id}/parcels`, { queryStringParameters: null, cancelToken: source.token }).then((titleDetails) => {
        const state = this.state.state_code;

        if (["NSW", "QLD", "SA", "VIC", "WA"].includes(state)) {
          titleDetails.sort((a, b) => {
            return a.plan_number - b.plan_number || a.lot_number - b.lot_number;
          });
        } else if (["ACT"].includes(state)) {
          titleDetails.sort((a, b) => {
            return a.block - b.block || a.section - b.section;
          });
        }

        if (titleDetails) {
          this.setState((state) => ({ titleDetails }));
          this.updateTitleDetailsString();
        }
      });
    } catch (e) {
      console.log("Error getting parcels:", e);
    }
  }

  toggleTitleDetailsModal = async () => {
    await this.setState((state) => ({
      showTitleDetailsDialog: !this.state.showTitleDetailsDialog,
    }));

    if (this.state.showTitleDetailsDialog === false && this.state.titleDetailsSaved) {
      this.setState({ titleDetailsSaved: false });
      this.updateTitleDetailsString();
    }
  };

  getVolumeFolios(fromModal = false) {
    try {
      API.get("colin", `/slmleases/${this.state.lease_id}/volume_folios`, { queryStringParameters: null }).then((volumeFolios) => {
        if (fromModal) {
          let updatedVolumeFolios = [...this.state.volumeFolios].map((uvf) => {
            const matchingVf = volumeFolios.find((vf) => vf.volume_folio_id === uvf.volume_folio_id);
            return matchingVf ? matchingVf : uvf;
          });
          this.setState({ volumeFolios: updatedVolumeFolios });
          return;
        }
        this.setState((state) => ({ volumeFolios }));
      });
    } catch {
      console.log("Error getting volume folios");
    }
  }

  toggleVolumeFoliosModal = async () => {
    await this.setState((state) => ({
      showVolumeFoliosDialog: !this.state.showVolumeFoliosDialog,
    }));

    if (this.state.showVolumeFoliosDialog === false && this.state.volumeFoliosSaved) {
      this.setState({ volumeFoliosSaved: false });
      this.updateTitleDetailsString();
    }
  };

  async getIntegrations() {
    console.log("getIntegrations() called");

    const response = await API.get("colin", `/slmleases/${this.state.lease_id}/integrations`);

    await this.setState({ integrations: response });

    console.log("raw response:", response);
  }

  togglePropertyIntegrationsModal = async () => {
    this.setState((state) => ({
      showAddressMatchingDialog: !this.state.showAddressMatchingDialog,
    }));
  };

  loadTitleDetailsRetry() {
    setTimeout(() => {
      console.log("getTitleDetails, 30000");
      this.getTitleDetails();
    }, 30000)
    setTimeout(() => {
      console.log("getTitleDetails, 60000");
      this.getTitleDetails();
    }, 60000)
    setTimeout(() => {
      console.log("getTitleDetails, 90000");
      this.getTitleDetails();
    }, 90000)
  }
  
  async saveIntegration(integration) {
    integration.last_edited_date = new Date();
    integration.last_edited_by = this.props.user;

    this.loadTitleDetailsRetry();

    await API.put("colin", `/slmleases/${this.state.lease_id}/integrations/${integration.property_integration_id}`, {
      body: integration,
    });

    return integration;
  }

  /**
   * Re-matches and updates integrations for all sales and leases of the related address.
   * @param {number} address_id - The id of the address.
   */
  async updateRelatedIntegrations(address_id) {
    return await API.put("colin", "/slmleases/integrations/related/new", {
      body: address_id,
    });
  }

  acceptIntegration(row, e) {
    row.original.is_accepted = true;
    row.original.accept_reject_by = this.props.user;

    this.saveIntegration(row.original);
    this.setState(this.state);
  }

  rejectIntegration(row, e) {
    row.original.is_accepted = false;
    row.original.accept_reject_by = this.props.user;

    this.saveIntegration(row.original);
    this.setState(this.state);
  }

  /**
   * Updates the integrations for this lease and all other leases and sales for the related address.
   */
  async updateIntegrations() {
    const response = await this.updateRelatedIntegrations(this.state.address_id);
    if (response.result !== true) {
      console.warn(response.error_message);
    }
    await this.getIntegrations();
  }

  async updateTitleDetailsString() {
    const response = await this.getLease();
    await this.setState({ title_details: response.title_details });
    await this.setState({ lease_notes_computed: response.lease_notes_computed });

    // const validVfs = [...this.state.volumeFolios].filter(vf => (!!vf.volume && !!vf.folio) || !!vf.other);
    // const validTds = [...this.state.titleDetails].filter(td => !!td.jurisdiction_id);
    // let newTitleDetailsStr = '';

    // if (validTds.length > 0) {
    //     const tdsString = validTds.map(td => td.jurisdiction_id).join(', ');
    //     newTitleDetailsStr += `RPD: ${tdsString||''}. `;
    // }

    // if (validVfs.length > 0) {
    //     const vfsString = validVfs.map(vf => {
    //         if (vf.volume && vf.folio) { return `V${vf.volume} F${vf.folio}` }
    //         return vf.other
    //     }).join(', ')
    //     newTitleDetailsStr += `Title Ref: ${vfsString||''}. `;
    // }

    // await this.setState({ title_details: newTitleDetailsStr.trim() });

    // const lease = {...this.state.lease};
    // lease.title_details = newTitleDetailsStr;
    // this.saveLease(lease)
  }

  render() {
    const currencyFormatter = new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 0,
      // maximumFractionDigits: 2
    });

    // const numberFormatter = new Intl.NumberFormat("en-AU", {
    //   style: "decimal",
    //   minimumFractionDigits: 0,
    //   maximumFractionDigits: 0,
    // });
    return (
      <div className="Lease">
        {this.state.isLoading && (
          <div className="outer-div">
            <div className="sweet-loading inner-div">
              <PacmanLoader
                css="display: block;
                            margin: 0 auto;
                             border-color: red"
                sizeUnit={"px"}
                size={20}
                color={"#e03c31"}
                loading={this.state.isLoading}
              />
            </div>
          </div>
        )}

        {this.state.lease && this.props.isAuthenticated && !this.state.isLoading && (
          <Form>
            <Modal
              show={this.state.showAlert && this.state.lease_id ? true : false}
              onHide={(e) => {
                this.setState({ showAlert: !this.state.showAlert });
              }}
              centered
            >
              <Modal.Header closeButton>
                {" "}
                <Modal.Title>Uh Oh!</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {" "}
                <Alert variant="danger">{this.state.errorMessage}</Alert>{" "}
              </Modal.Body>
            </Modal>
            {this.state.showAlert && !this.state.lease_id && <Alert variant="danger">{this.state.errorMessage}</Alert>}

            <Form.Row>
              <Col sm={4} md={6} lg={6}>
                <h6>
                  Lease Details - {this.state.lease_type} | {this.state.stat_date} |{this.state.lease_level || ""} {this.state.building_name || ""} | {this.state.street_address_full || ""} {this.state.suburb || ""} {this.state.state_code || ""} {this.state.postcode || ""}
                </h6>
              </Col>
              <Col>
                <Nav className="justify-content-center ">
                  {this.state.previousId !== null && this.state.idList.length > 0 && (
                    <Nav.Item>
                      <LinkContainer to={{ pathname: `/slmleases/${this.state.previousId}`, state: { data: this.state.idList } }}>
                        <Button type="button" variant="info" size="sm">
                          Previous
                        </Button>
                      </LinkContainer>{" "}
                    </Nav.Item>
                  )}

                  {this.state.nextId !== null && this.state.idList.length > 0 && (
                    <Nav.Item>
                      <LinkContainer to={{ pathname: `/slmleases/${this.state.nextId}`, state: { data: this.state.idList } }}>
                        <Button type="button" variant="info" size="sm">
                          Next
                        </Button>
                      </LinkContainer>{" "}
                    </Nav.Item>
                  )}
                  {this.state.currentIdIndex !== null && this.state.idList.length > 0 && (
                    <Form.Group as={Row} controlId="currentIdIndex">
                      <Col className="zeroPadRight">
                        <Form.Control onChange={this.handleCurrentIdIndexChange} value={this.state.currentIdIndex + 1} as="input" type="text" min="0" className="pageCount" onBlur={this.handleGoToRecord} onKeyDown={this.handleEnterCurrentIdIndex} />
                      </Col>
                      <Col className="zeroPadLeft">
                        <h6>
                          <div className="topPad">of {this.state.idList.length} </div>
                        </h6>
                      </Col>
                    </Form.Group>
                  )}
                </Nav>
              </Col>

              <Col>
                <Nav className="justify-content-end ">
                  <Nav.Item>
                    <LinkContainer to={{ pathname: `/slmleases/new`, state: { address_id: this.state.address_id, address_hard_sequence: this.state.address_hard_sequence, building_name: this.state.building_name, floor_unit: this.state.floor_unit, street_no_low: this.state.street_no_low, street_no_high: this.state.street_no_high, street_name: this.state.street_name, extension: this.state.extension, suburb: this.state.suburb, state_code: this.state.state_code, postcode: this.state.postcode } }}>
                      <Button variant="primary" type="button" size="sm">
                        New Lease
                      </Button>
                    </LinkContainer>{" "}
                  </Nav.Item>
                  <Nav.Item>
                    <a href={`/slmaddresses/${this.state.address_id}`}>
                      <Button variant="primary" size="sm" type="button">
                        Back to Address
                      </Button>
                    </a>{" "}
                  </Nav.Item>
                  <Nav.Item>
                    <Button variant="danger" type="button" onClick={this.handleDelete} size="sm">
                      Delete Lease
                    </Button>
                  </Nav.Item>
                </Nav>
              </Col>
            </Form.Row>

            <Form.Row id="detail">
              <Col sm={3} md={3} lg={3}>
                <Form.Group as={Row}>
                  <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                    CoLin ID
                  </Form.Label>
                  <Col>
                    <Form.Control disabled readOnly onChange={this.handleChange} value={this.state.lease_id} type="text" id="address_id" onBlur={this.handleBlur} />
                  </Col>

                  <Form.Label as={Col} className="text-right" column sm={4} md={4} lg={2}>
                    PIMs ID
                  </Form.Label>
                  <Col>
                    <Form.Control disabled readOnly onChange={this.handleChange} value={this.state.hard_sequence} type="text" id="address_id" onBlur={this.handleBlur} />
                  </Col>
                </Form.Group>
                <Card id="leasedetails">
                  <Card.Header>Property Address</Card.Header>
                  <Card.Body>
                    <Form.Group as={Row}>
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        CoLin ID
                      </Form.Label>
                      <Col>
                        <Form.Control disabled readOnly onChange={this.handleChange} value={this.state.address_id} type="text" id="address_id" onBlur={this.handleBlur} />
                      </Col>

                      <Form.Label as={Col} className="text-right" column sm={4} md={4} lg={2}>
                        PIMs ID
                      </Form.Label>
                      <Col>
                        <Form.Control disabled readOnly onChange={this.handleChange} value={this.state.address_hard_sequence} type="text" id="address_id" onBlur={this.handleBlur} />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="building_name">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Building Name
                      </Form.Label>
                      <Col>
                        <Form.Control onChange={this.handleChange} value={this.state.building_name} type="text" readOnly />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row}>
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Street Address
                      </Form.Label>
                      <Col>
                        <Form.Control onChange={this.handleChange} value={this.state.street_address_full} type="text" id="street_name" readOnly />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row}>
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}></Form.Label>
                      <Col>
                        <Form.Control onChange={this.handleChange} value={(this.state.suburb || "") + " " + (this.state.state_code || "") + " " + (this.state.postcode || "")} as="input" type="text" id="state_code" readOnly />
                      </Col>
                    </Form.Group>
                    <Form.Row>
                      <Col column sm={6} md={6} lg={4}></Col>
                      <Col className="text-right">
                        <LinkContainer to={{ pathname: `/slmaddresses/${this.state.address_id}`, state: { lease_id: this.state.lease_id } }}>
                          <Button variant="primary" type="button" size="sm">
                            Edit Address
                          </Button>
                        </LinkContainer>{" "}
                      </Col>
                    </Form.Row>

                    <Form.Group as={Row} className="mt-2">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Unit Number
                      </Form.Label>
                      <Col>
                        <Form.Control onChange={this.handleChange} onBlur={this.handleBlur} value={this.state.unit_number} type="text" as="input" id="unit_number" />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="property_integrations">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        CoreLogic Equivalent Properties
                      </Form.Label>
                      <Col>
                        <Button onClick={this.togglePropertyIntegrationsModal} size="sm" variant="secondary" type="button">
                          Edit
                        </Button>
                        <RefreshButton onClick={this.updateIntegrations} onTimeout={this.getIntegrations} timeout={90000} size="sm" variant="secondary" type="button" style={{float: "right"}} />
                        <PropertyIntegrationsList filter={{ leaseid: this.state.lease_id }} isAuthenticated={this.props.isAuthenticated} controlType="list" data={this.state.integrations} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} acceptIntegration={this.acceptIntegration} rejectIntegration={this.rejectIntegration} ctx="slmlease" />

                        {this.state.showAddressMatchingDialog && <PropertyIntegrationsModal show={this.state.showAddressMatchingDialog} onClose={this.togglePropertyIntegrationsModal} filter={{ leaseid: this.state.lease_id }} isAuthenticated={this.props.isAuthenticated} toggleAddressModal={this.togglePropertyIntegrationsModal} user={this.props.user} data={this.state.integrations} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} validateRelatedRecord={this.validateRelatedRecord} streetOptions={this.state.streetOptions} acceptIntegration={this.acceptIntegration} rejectIntegration={this.rejectIntegration} ctx="slmlease" />}
                      </Col>
                    </Form.Group>
                  </Card.Body>
                </Card>

                <Card>
                  <Card.Body>
                    <Form.Group as={Row} controlId="title_details">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Title Details
                      </Form.Label>
                      <Col>
                        <Form.Control onChange={this.handleChange} value={this.state.title_details} as="textarea" type="text" rows="5" disabled={true} />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="parcels">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Parcels
                        <br />
                        (Top 3 - click Edit to view all)
                      </Form.Label>
                      <Col>
                        <Button onClick={this.toggleTitleDetailsModal} size="sm" variant="secondary" type="button" disabled={this.state.head_record_property_id ? true : false}>
                          Edit
                        </Button>
                        <TitleDetailsList
                          filter={{ leaseid: this.state.lease_id }}
                          isAuthenticated={this.props.isAuthenticated}
                          controlType="list"
                          data={this.state.titleDetails}
                          dataFetch={this.getTitleDetails}
                          updateTableState={this.updateTableState}
                          saveRecord={this.saveRecord}
                          context="slmlease"
                          stateCode={this.state.state_code}
                          listAmount="3"
                          // deleteRecord={this.deleteRecord}
                        />

                        {this.state.showTitleDetailsDialog && <TitleDetailsModal show={this.state.showTitleDetailsDialog} onClose={this.toggleTitleDetailsModal} filter={{ leaseid: this.state.lease_id }} isAuthenticated={this.props.isAuthenticated} toggleTitleDetailsModal={this.toggleTitleDetailsModal} user={this.props.user} data={this.state.titleDetails} dataFetch={this.getTitleDetails} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} validateRelatedRecord={this.validateRelatedRecord} context="slmlease" stateCode={this.state.state_code} />}
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="volume_folios">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Volume Folios
                        <br />
                        (Top 3 - click Edit to view all)
                      </Form.Label>
                      <Col>
                        <Button onClick={this.toggleVolumeFoliosModal} size="sm" variant="secondary" type="button" disabled={this.state.head_record_property_id ? true : false}>
                          Edit
                        </Button>
                        <VolumeFoliosList filter={{ leaseid: this.state.lease_id }} isAuthenticated={this.props.isAuthenticated} controlType="list" data={this.state.volumeFolios} dataFetch={this.getVolumeFolios} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} context="slmlease" listAmount="3" />

                        {this.state.showVolumeFoliosDialog && <VolumeFoliosModal show={this.state.showVolumeFoliosDialog} onClose={this.toggleVolumeFoliosModal} filter={{ leaseid: this.state.lease_id }} isAuthenticated={this.props.isAuthenticated} toggleVolumeFoliosModal={this.toggleVolumeFoliosModal} user={this.props.user} data={this.state.volumeFolios} dataFetch={this.getVolumeFolios} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} validateRelatedRecord={this.validateRelatedRecord} context="slmlease" />}
                      </Col>
                    </Form.Group>
                  </Card.Body>
                </Card>
              </Col>

              <Col sm={3} md={3} lg={3}>
                <Card>
                  <Card.Header>References </Card.Header>

                  <Card.Body>
                    <Form.Row>
                      <Col lg={0.5}> </Col>
                      <Col>Reference</Col>
                      <Col>Date</Col>
                      <Col>Page</Col>
                    </Form.Row>
                    <Form.Row>
                      <Col lg={0.5}>1</Col>
                      <Col>
                        <Select value={this.state.selectedSourceCategories1} onChange={this.handleSource1Change} options={this.props.sourcecategoryOptions} id="source_cat_1" isClearable />
                      </Col>
                      <Col>
                        <DatePicker selected={this.state.source_date_1 !== null ? new Date(this.state.source_date_1) : null} onChange={(e) => this.handleDateChange(e, "source_date_1")} onBlur={this.handleBlur} dateFormat="dd/MM/yyyy" className="form-control" isClearable={true} />
                      </Col>
                      <Col>
                        <Form.Control onChange={this.handleChange} value={this.state.source_page_1} as="input" type="number" id="source_page_1" onBlur={this.handleBlur} />
                      </Col>
                    </Form.Row>
                    <Form.Row>
                      <Col lg={0.5}>2</Col>
                      <Col>
                        <Select value={this.state.selectedSourceCategories2} onChange={this.handleSource2Change} options={this.props.sourcecategoryOptions} id="source_cat_2" isClearable />
                      </Col>
                      <Col>
                        <DatePicker selected={this.state.source_date_2 !== null ? new Date(this.state.source_date_2) : null} onChange={(e) => this.handleDateChange(e, "source_date_2")} onBlur={this.handleBlur} dateFormat="dd/MM/yyyy" className="form-control" isClearable={true} />
                      </Col>
                      <Col>
                        <Form.Control onChange={this.handleChange} value={this.state.source_page_2} as="input" type="number" id="source_page_2" onBlur={this.handleBlur} />
                      </Col>
                    </Form.Row>
                    <Form.Row>
                      <Col lg={0.5}>3</Col>
                      <Col>
                        <Select value={this.state.selectedSourceCategories3} onChange={this.handleSource3Change} options={this.props.sourcecategoryOptions} id="source_cat_3" isClearable />
                      </Col>
                      <Col>
                        <DatePicker selected={this.state.source_date_3 !== null ? new Date(this.state.source_date_3) : null} onChange={(e) => this.handleDateChange(e, "source_date_3")} onBlur={this.handleBlur} dateFormat="dd/MM/yyyy" className="form-control" isClearable={true} />
                      </Col>
                      <Col>
                        <Form.Control onChange={this.handleChange} value={this.state.source_page_3} as="input" type="number" id="source_page_3" onBlur={this.handleBlur} />
                      </Col>
                    </Form.Row>
                  </Card.Body>
                </Card>

                <Card>
                  <Card.Header>Space Information</Card.Header>
                  <Card.Body>
                    <Form.Group as={Row} controlId="lease_status_cat">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Status (existing/precom)
                      </Form.Label>
                      <Col>
                        <Select value={this.state.selectedLeaseStatusCategories} onChange={this.handleStatusChange} options={this.props.leasestatuscategoryOptions} isClearable />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="broad_space_use_name">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Broad Space Use
                      </Form.Label>
                      <Col>
                        <Select
                          value={this.state.selectedBroadSpaceUseCategories}
                          onChange={this.handleBroadSpaceUseChange}
                          options={this.props.broadspaceusecategoryOptions.filter((a) => {
                            if (a.value === this.state.broad_space_use_id || this.state.broad_space_use_id === null || this.state.broad_space_use_id === 1) {
                              return true;
                            } else {
                              return false;
                            }
                          })}
                          isClearable
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="space_use_name">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Detailed Space Use
                      </Form.Label>
                      <Col>
                        <Select
                          value={this.state.selectedSpaceUseCategories}
                          onChange={this.handleSpaceUseChange}
                          options={this.props.spaceusecategoryOptions.filter((a) => {
                            if (a.supplementary_details.broad_space_use_id === this.state.broad_space_use_id || this.state.broad_space_use_id === null) {
                              return true;
                            } else {
                              return false;
                            }
                          })}
                          isClearable
                          //isDisabled={!this.state.broad_space_use_id?true:false}
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="lease_method">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Lease Method/Type
                      </Form.Label>
                      <Col>
                        <Select value={this.state.selectedLeaseMethodCategories} onChange={this.handleLeaseMethodChange} options={this.props.leasemethodcategoryOptions} isClearable />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="tenant_area">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Area SQM
                      </Form.Label>
                      <Col>
                        <Form.Control onChange={this.handleNumberChange} value={this.state.tenant_area} as="input" type="text" onBlur={this.handleBlur} />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="level_description">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Level Description
                      </Form.Label>
                      <Col>
                        <Select value={this.state.selectedLevelCategories} onChange={this.handleLevelCategoryChange} options={this.props.leaselevelcategoryOptions} isClearable />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="lease_level">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Suite/Level
                      </Form.Label>
                      <Col>
                        <Form.Control onChange={this.handleChange} value={this.state.lease_level} as="input" type="text" onBlur={this.handleBlur} />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="cars">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Car Bays
                      </Form.Label>
                      <Col>
                        <Form.Control onChange={this.handleNumberChange} value={this.state.cars} as="input" type="text" onBlur={this.handleBlur} />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="car_space_describer">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Parking Describer
                      </Form.Label>
                      <Col>
                        <Select value={this.state.selectedCarSpaceCategories} onChange={this.handleCarSpaceChange} options={this.props.carspacecategoryOptions} isClearable />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="quality_type">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Quality
                      </Form.Label>
                      <Col>
                        <Select value={this.state.selectedQualityTypeCategories} onChange={this.handleQualityTypeChange} options={this.props.qualitytypecategoryOptions} isClearable />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="lease_notes">
                      <Form.Label>
                        <b>Extra lease notes (appear to customers)</b>
                      </Form.Label>
                      <Form.Control onChange={this.handleChange} onBlur={this.handleBlur} value={this.state.lease_notes} as="textarea" type="text" rows="2" />
                    </Form.Group>

                    <Form.Group as={Row} controlId="lease_notes_computed">
                      <Form.Label
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          marginTop: "5px",
                        }}
                      >
                        <div>
                          <b>New auto-generated Lease Notes</b>
                        </div>
                        {goLive <= new Date(this.state.print_month) && (
                          <div>
                            <b
                              style={{
                                float: "right",
                                color: "red",
                                textAlign: "right",
                              }}
                            >
                              **Currently visible to customers**
                            </b>
                          </div>
                        )}
                        <OverlayTrigger
                          trigger="click"
                          key="info"
                          placement="top"
                          overlay={
                            <Popover
                              id={`info-popover`}
                              style={{
                                maxWidth: "800px",
                              }}
                            >
                              <Popover.Title>Info</Popover.Title>
                              <Popover.Content>
                                {`In April 2023 - as part of the changes required for Commercial APIs - we moved the entry of lots/plans, volumes/folios and Transfer Number from the free-text Lease Notes, into separate Parcels and Titles References tables. 
We also introduced a "New auto-generated Lease Notes" field - which automatically creates Lease Notes text for PIM customers. 
We also retained the "Old Lease Notes - pre API 2023 changes".
Which does the customer see?
For older records with a Delivery Date earlier than the changes introduced April 2023, by default the customer sees the "Old Lease Notes - pre API 2023 changes". 
For new records since April 2023, the customer will see the "New auto-generated Lease Notes".
This also applies for older records redelivered since April 2023.
To make it clear which the customer is seeing, the text "**Currently visible to customers**" appears.
Note: When a new record is entered or an older record is redelivered, the onus is on the user to check the "New auto-generated Lease Notes" field appears correct.
The "New auto-generated Lease Notes" field cannot be edited directly and is built from Parcels, Volume/Folios, Transfer Number (where SOLD) and any entered "Extra lease notes".`}
                              </Popover.Content>
                            </Popover>
                          }
                        >
                          <Button
                            className="rounded-circle"
                            variant="outline-primary"
                            size="sm"
                            style={{
                              width: "20px",
                              height: "20px",
                              padding: "0px",
                              textAlign: "center",
                            }}
                          >
                            {<Info />}
                          </Button>
                        </OverlayTrigger>
                      </Form.Label>
                      <Form.Control onChange={this.handleChange} onBlur={this.handleBlur} value={typeof this.state.lease_notes_computed === "string" ? this.state.lease_notes_computed.trim() : this.state.lease_notes_computed} as="textarea" type="text" rows="5" disabled={true} />
                    </Form.Group>
                    <Form.Group as={Row} controlId="note_data">
                      <Form.Label
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>
                          <b>Old Lease Notes - pre API 2023 changes</b>
                        </div>
                        {goLive > new Date(this.state.print_month) && (
                          <div>
                            <b
                              style={{
                                float: "right",
                                color: "red",
                                textAlign: "right",
                              }}
                            >
                              **Currently visible to customers**
                            </b>
                          </div>
                        )}
                      </Form.Label>
                      <Form.Control onChange={this.handleChange} onBlur={this.handleBlur} value={this.state.note_data} as="textarea" type="text" rows="5" disabled={true} />
                    </Form.Group>
                  </Card.Body>
                </Card>
              </Col>

              <Col sm={3} md={3} lg={3}>
                <Card>
                  <Card.Header>Lease Information</Card.Header>

                  <Card.Body>
                    <Form.Row>
                      <Col>
                        <Form.Group as={Row} controlId="stat_date">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Stats Date
                          </Form.Label>
                          <Col>
                            <DatePicker selected={this.state.stat_date !== null ? new Date(this.state.stat_date) : null} onChange={(e) => this.handleDateChange(e, "stat_date")} onBlur={this.handleBlur} dateFormat="dd/MM/yyyy" className="form-control" isClearable={true} />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="lease_commence_date">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Commencement Date
                          </Form.Label>
                          <Col>
                            <DatePicker selected={this.state.lease_commence_date !== null ? new Date(this.state.lease_commence_date) : null} onChange={(e) => this.handleDateChange(e, "lease_commence_date")} onBlur={this.handleBlur} dateFormat="dd/MM/yyyy" className="form-control" isClearable={true} />
                          </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="term">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Lease Term
                          </Form.Label>
                          <Col>
                            <Form.Control onChange={this.handleNumberChange} value={this.state.term} as="input" type="text" onBlur={this.handleBlur} />
                          </Col>
                          <Col>years</Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="options">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Options Text
                          </Form.Label>
                          <Col>
                            <Form.Control onChange={this.handleChange} value={this.state.options} as="input" type="text" onBlur={this.handleBlur} />
                          </Col>
                          <Col>x + x format</Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="review">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Reviews every
                          </Form.Label>
                          <Col>
                            <Form.Control onChange={this.handleChange} value={this.state.review} as="input" type="text" onBlur={this.handleBlur} />
                          </Col>
                          <Col>years</Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="review_basis">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Lease Review Basis
                          </Form.Label>
                          <Col>
                            <Select value={this.state.selectedReviewBasisCategories} onChange={this.handleReviewBasisCategoryChange} options={this.props.leaselreviewbasiscategoryOptions} isClearable />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="rent_per_annum">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Rent per Annum
                          </Form.Label>
                          <Col>
                            <Form.Control onChange={this.handleNumberChange} value={this.state.rent_per_annum ? currencyFormatter.format(this.state.rent_per_annum) : this.state.rent_per_annum} as="input" type="text" onBlur={this.handleBlur} />
                          </Col>
                          <Col style={{ "vertical-align": "top" }}>
                            <Select value={this.state.selectedRentPerAnnumBasisCategories} onChange={this.handleRentPerAnnumBasisCategoryChange} options={this.props.rentperannumbasiscategoryOptions} isClearable />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="rent">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Rent per SQM
                          </Form.Label>
                          <Col>
                            <Form.Control onChange={this.handleNumberChange} value={this.state.rent ? currencyFormatter.format(this.state.rent) : this.state.rent} as="input" type="text" onBlur={this.handleBlur} />
                          </Col>
                          <Col style={{ "vertical-align": "top" }}>
                            <Select value={this.state.selectedRentBasisCategories} onChange={this.handleRentBasisCategoryChange} options={this.props.rentpersqmbasiscategoryOptions} isClearable />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="estimated">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Rental Estimated?
                          </Form.Label>
                          <Col>
                            <Form.Check checked={this.state.estimated} onChange={this.handleCheckBoxChange} name="estimated" type="checkbox" />
                          </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="car_rate">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Car Rate pcm
                          </Form.Label>
                          <Col>
                            <Form.Control onChange={this.handleNumberChange} value={this.state.car_rate ? currencyFormatter.format(this.state.car_rate) : this.state.car_rate} as="input" type="text" onBlur={this.handleBlur} />
                          </Col>
                          <Col>per calendar month</Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="outgoings">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Outgoings per SQM
                          </Form.Label>
                          <Col>
                            {/* <Form.Control
                                                onChange={this.handleNumberChange}
                                                
                                                value={this.state.outgoings? currencyFormatter.format(this.state.outgoings):this.state.outgoings}
                                                as="input"
                                                type="text"
                                                onBlur={this.handleBlur}

                                            /> */}
                            <CurrencyField name="outgoings" value={this.state.outgoings} onChange={this.handleMoneyChange} onBlur={this.handleBlur} />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="outgoings_cat">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Outgoings Basis
                          </Form.Label>

                          <Col style={{ "vertical-align": "top" }}>
                            <Select value={this.state.selectedOutgoingsCategories} onChange={this.handleOutgoingsCategoryChange} options={this.props.leaseoutgoingscategoryOptions} isClearable />
                          </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="editors_note">
                          <Form.Label>
                            <b>Editors Notes</b>
                            <br />
                            (Unpublished)
                          </Form.Label>

                          <Form.Control onChange={this.handleChange} value={this.state.editors_note} as="textarea" type="text" rows="5" onBlur={this.handleBlur} bsPrefix="internal" />
                        </Form.Group>
                      </Col>
                    </Form.Row>
                  </Card.Body>
                </Card>
              </Col>

              <Col sm={3} md={3} lg={3}>
                <Card>
                  <Card.Header>Record Deliver</Card.Header>
                  <Card.Body>
                    <Form.Row>
                      <Col className="text-right">
                        <Button variant="primary" size="sm" type="button" onClick={this.handleRedeliver}>
                          Redeliver
                        </Button>
                      </Col>
                    </Form.Row>

                    <Form.Row className="mt-1">
                      <Col>
                        <Form.Group controlId="prev_delivery">
                          <Form.Label>Prev. Delivery Date</Form.Label>
                          <br />
                          <DatePicker selected={this.state.prev_delivery !== null ? new Date(this.state.prev_delivery) : null} onChange={(e) => this.handleDateChange(e, "prev_delivery")} onBlur={this.handleBlur} dateFormat="dd/MM/yyyy" className="form-control" disabled />
                        </Form.Group>
                      </Col>

                      <Col>
                        <Form.Group controlId="print_month">
                          <Form.Label>Delivery Date</Form.Label>
                          <br />
                          <DatePicker selected={this.state.print_month !== null ? new Date(this.state.print_month) : null} onChange={(e) => this.handleDateChange(e, "print_month")} onBlur={this.handleBlur} dateFormat="dd/MM/yyyy" className="form-control" isClearable={true} />
                        </Form.Group>
                      </Col>
                    </Form.Row>

                    <Form.Row>
                      <Form.Group controlId="pending" className="pl-1 pt-1">
                        <Form.Check checked={this.state.pending} onChange={this.handleCheckBoxChange} name="pending" type="checkbox" id="pending" label="Pending?" />
                      </Form.Group>
                    </Form.Row>
                  </Card.Body>
                </Card>

                <Card>
                  <Card.Header>Agents & Agencies</Card.Header>
                  <Card.Body>
                    <Form.Group as={Form.Row} controlId="agent">
                      <Form.Label className="text-right" column sm={4} md={4} lg={2}>
                        Agent
                      </Form.Label>
                      <Col>
                        <Form.Control
                          // disabled
                          readOnly={this.state.entityLinks.length > 0 ? true : false}
                          onChange={this.handleChange}
                          onBlur={this.handleBlur}
                          value={this.state.agent}
                          as="input"
                          type="text"
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Form.Row} controlId="agency">
                      <Form.Label className="text-right" column sm={4} md={4} lg={2}>
                        Agency
                      </Form.Label>
                      <Col>
                        <Form.Control readOnly={this.state.entityLinks.length > 0 ? true : false} onChange={this.handleChange} onBlur={this.handleBlur} value={this.state.agency} as="input" type="text" />
                      </Col>
                    </Form.Group>

                    <Form.Row>
                      <Col>
                        <SLMEntityLinkList isAuthenticated={this.props.isAuthenticated} controlType="table2" data={this.state.entityLinks} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} sale_id={null} lease_id={this.state.lease_id} user={this.props.user} state_code={this.state.state_code} validateRelatedRecord={this.validateRelatedRecord} getAgencies={this.getAgencies} getAgents={this.getAgents} getEntityLinks={this.getEntityLinks} updateAgencyFields={this.updateAgencyFields} />
                      </Col>
                    </Form.Row>
                  </Card.Body>
                </Card>

                <Card>
                  <Card.Header>Lessee/Lessor</Card.Header>
                  <Card.Body>
                    <Form.Group as={Row} controlId="lessee">
                      <Form.Label className="text-right" column sm={4} md={4} lg={2}>
                        Lessee
                      </Form.Label>
                      <Col>
                        <Form.Control readOnly={this.state.ownerLinks.filter((f) => f.type === "Lessee").length > 0 ? true : false} onChange={this.handleChange} onBlur={this.handleBlur} value={this.state.lessee} as="input" type="text" />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="owner">
                      <Form.Label className="text-right" column sm={4} md={4} lg={2}>
                        Lessor
                      </Form.Label>
                      <Col>
                        <Form.Control readOnly={this.state.ownerLinks.filter((f) => f.type === "Lessor").length > 0 ? true : false} onChange={this.handleChange} onBlur={this.handleBlur} value={this.state.owner} as="input" type="text" />
                      </Col>
                    </Form.Group>

                    <Form.Row>
                      <Col>
                        <SLMOwnerLinkList isAuthenticated={this.props.isAuthenticated} controlType="table2" data={this.state.ownerLinks} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} sale_id={null} lease_id={this.state.lease_id} user={this.props.user} state_code={this.state.state_code} validateRelatedRecord={this.validateRelatedRecord} getOwners={this.getOwners} getContacts={this.getContacts} getOwnerLinks={this.getOwnerLinks} updateVendorFields={this.updateVendorFields} />
                      </Col>
                    </Form.Row>
                  </Card.Body>
                </Card>

                <Card>
                  <Card.Header>History</Card.Header>
                  <Card.Body>
                    <Form.Row>
                      <Col>
                        <Form.Group as={Row} controlId="created_by">
                          <Form.Label className="text-right" column sm={5} md={5} lg={5}>
                            Created By
                          </Form.Label>
                          <Col>
                            <Form.Control disabled readOnly value={this.state.created_by} as="input" type="text" />
                          </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="created_date">
                          <Form.Label className="text-right" column sm={5} md={5} lg={5}>
                            Created Date
                          </Form.Label>
                          <Col>
                            <DatePicker
                              selected={this.state.created_date !== null ? new Date(this.state.created_date) : null}
                              onChange={(e) => this.handleDateChange(e, "created_date")}
                              //   onBlur={this.handleBlur}
                              dateFormat="dd/MM/yyyy"
                              className="form-control"
                              disabled
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group as={Row} controlId="last_edited_by">
                          <Form.Label className="text-right" column sm={5} md={5} lg={5}>
                            Last Edited By
                          </Form.Label>
                          <Col>
                            <Form.Control disabled readOnly value={this.state.last_edited_by} as="input" type="text" />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="last_edited_date">
                          <Form.Label className="text-right" column sm={5} md={5} lg={5}>
                            Last Edited Date
                          </Form.Label>
                          <Col>
                            <DatePicker
                              selected={this.state.last_edited_date !== null ? new Date(this.state.last_edited_date) : null}
                              onChange={(e) => this.handleDateChange(e, "last_edited_date")}
                              //   onBlur={this.handleBlur}
                              dateFormat="dd/MM/yyyy"
                              className="form-control"
                              disabled
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Form.Row>
                  </Card.Body>
                </Card>
              </Col>
            </Form.Row>
          </Form>
        )}
      </div>
    );
  }
}
